import { useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

interface IProps {
  text?: string;
  height?: string;
  placeholder?: string;
  readOnly?: boolean;
  onChange?: (value: string) => void;
}

export const TextAreaQuill = ({
  text,
  height = "300px",
  placeholder = "Digite seu texto aqui...",
  readOnly = false,
  onChange,
}: IProps) => {
  // --- Use Status Control --- //
  const [value, setValue] = useState(text || "");

  const handleChange = (content: string) => {
    setValue(content);
    onChange?.(content);
  };

  return (
    <div className="quill-editor-container">
      <ReactQuill
        theme="snow"
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        readOnly={readOnly}
        style={{
          height: height,
          marginBottom: "50px",
        }}
      />
    </div>
  );
};
